export const Role = {
    Admin: 'a',
    Internal: 'i',
    External: 'e'
}